var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrowLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 15,
    viewBox: "0 0 34 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08499 14.794L8.50239 14.3798C8.77897 14.1052 8.77897 13.66 8.50239 13.3854L3.54833 8.49607H33.2917C33.6828 8.49607 34 8.18124 34 7.79294V7.20701C34 6.81871 33.6828 6.50388 33.2917 6.50388H3.54833L8.50239 1.61456C8.77897 1.34002 8.77897 0.894843 8.50239 0.620184L8.08499 0.205908C7.80841 -0.068636 7.35988 -0.068636 7.08331 0.205908L0.207433 7.00279C-0.0691444 7.27739 -0.0691444 7.72256 0.207433 7.99722L7.08331 14.7941C7.35988 15.0686 7.80841 15.0686 8.08499 14.794Z",
    fill: "#1752AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowLarge);
export default __webpack_public_path__ + "static/media/LeftArrowLarge.6f6b4152e2f270e370e8ba06d82a2112.svg";
export { ForwardRef as ReactComponent };